import React from 'react';
import { ChevronDown } from 'lucide-react';
import './Select.css';

export function Select({ label, error, hint, options = [], className = '', id, placeholder, ...props }) {
  const selectId = id || (label ? `select-${label.replace(/\s/g, '-').toLowerCase()}` : undefined);

  return (
    <div className={`ui-select-wrap ${error ? 'ui-select-wrap--error' : ''} ${className}`}>
      {label && <label className="ui-select__label" htmlFor={selectId}>{label}</label>}
      <div className="ui-select__container">
        <select className="ui-select" id={selectId} {...props}>
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt) => {
            const value = typeof opt === 'object' ? opt.value : opt;
            const optLabel = typeof opt === 'object' ? opt.label : opt;
            return <option key={value} value={value}>{optLabel}</option>;
          })}
        </select>
        <ChevronDown size={16} className="ui-select__chevron" />
      </div>
      {(error || hint) && (
        <span className={`ui-select__hint ${error ? 'ui-select__hint--error' : ''}`}>
          {error || hint}
        </span>
      )}
    </div>
  );
}
